import React, { useState } from 'react'

import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Ellipsis from 'react-ellipsis-component';

import styles from './MoreDetail.module.scss'
import clsx from 'clsx';

// const Break = (text) => {
//   const lines = text.split('\n')
//   return <>
//     //{lines.map(line => )}
//   </>
// }

const MoreDetail = ({pack}) => {
  const [open, setOpen] = useState(false)
  const backImageStyle = pack.cover ? {backgroundImage: `url(${pack.cover})`} : {}
  const content = pack.content || '';
  // if (content.length < LEN) {
  //   return <>{content}</>
  // }
  return <>
    {/* {content.substring(0, LEN)} */}
    <Ellipsis className={clsx(styles.detail, 'more-detail')} text={content} maxLine={2} ellipsisNode={
          <Typography className={styles['root']} component="span" onClick={() => setOpen(true)}> and More...</Typography>
    } reflowOnResize={true} />
    {/* <Typography className={styles['root']} component="span" onClick={() => setOpen(true)}> and More...</Typography> */}
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
      <div className={styles['dialog']}>
        <div className={styles['img']} style={backImageStyle}></div>
        <div className={styles['txt']}>
          <Typography component="p">
          {content}
          </Typography>
        </div>
      </div>
    </Dialog>
  </>
}

export default MoreDetail